import { z } from 'zod';

export const RequestApprovalValidateAccessSchema = z.object({
  code: z.string().length(6),
});

export type RequestApprovalValidateAccessForm = z.infer<
  typeof RequestApprovalValidateAccessSchema
>;
